/**
 * BoQ element type identifiers. Use for comparison (e.g. row.type === ELEMENT_TYPES.POSITION)
 * and when adding new elements. Reusable across editor, grid, and API.
 */
export const ELEMENT_TYPES = {
	GROUP: "group",
	SUBGROUP: "subgroup",
	POSITION: "position",
	NOTE: "note",
	ADDITIONAL_TEXT: "additional_text",
	EXECUTION_DESCRIPTION: "execution_description",
};

/** Background / accent color for each element type (grid row left-border, legend swatch, dropdown swatch). */
export const ELEMENT_TYPE_COLORS = {
	[ELEMENT_TYPES.GROUP]: "#2563eb", // blue-600
	[ELEMENT_TYPES.SUBGROUP]: "#16a34a", // green-600
	[ELEMENT_TYPES.POSITION]: "#6b7280", // gray-500
	[ELEMENT_TYPES.NOTE]: "#d97706", // amber-600
	[ELEMENT_TYPES.ADDITIONAL_TEXT]: "#9333ea", // purple-600
	[ELEMENT_TYPES.EXECUTION_DESCRIPTION]: "#ea580c", // orange-600
};

/** i18n keys for the in-row type badge pill. Use with t(). */
export const ELEMENT_TYPE_BADGE_LABELS = {
	[ELEMENT_TYPES.GROUP]: "boq.badge.group",
	[ELEMENT_TYPES.SUBGROUP]: "boq.badge.subgroup",
	[ELEMENT_TYPES.POSITION]: "boq.badge.position",
	[ELEMENT_TYPES.NOTE]: "boq.badge.note",
	[ELEMENT_TYPES.ADDITIONAL_TEXT]: "boq.badge.additional-text",
	[ELEMENT_TYPES.EXECUTION_DESCRIPTION]: "boq.badge.execution-description",
};

/** Options for the "Add" dropdown: type + i18n label key. ADDITIONAL_TEXT shows a submenu (at beginning / at end). */
export const BOQ_ADD_ELEMENT_OPTIONS = [
	{ type: ELEMENT_TYPES.GROUP, labelKey: "boq.add.group" },
	{ type: ELEMENT_TYPES.SUBGROUP, labelKey: "boq.add.subgroup" },
	{ type: ELEMENT_TYPES.POSITION, labelKey: "boq.add.position" },
	{ type: ELEMENT_TYPES.NOTE, labelKey: "boq.add.hint-text" },
	// {
	// 	type: ELEMENT_TYPES.ADDITIONAL_TEXT,
	// 	labelKey: "boq.add.additional-text",
	// },
	// {
	// 	type: ELEMENT_TYPES.EXECUTION_DESCRIPTION,
	// 	labelKey: "boq.add.execution-description",
	// },
];
